import React, { useMemo } from 'react';
import type { MultipleChoicePredictiveQuestionDto } from "@advanced-sales-technologies/backend-client/models/MultipleChoicePredictiveQuestionDto";

import { ComponentField } from '@/types/DynamicForm.type';
import { getQuestionLabel } from '@/utils/dynamicForm.util';
import FormOptionsCheckboxes from '@/components/molecules/form/FormOptionCheckboxes';

type Props = Extract<ComponentField, { fieldType: 'checkboxes' }>;

/**
 * Dynamic form field component for checkbox options selection
 * Processes options from question data and handles choice mapping
 * 
 * @param cfg - Field configuration object
 * @returns JSX element for the checkboxes field
 */
const DynamicFormCheckboxes: React.FC<Props> = (cfg) => {
  const question = cfg.question?.data as MultipleChoicePredictiveQuestionDto;

  const options = useMemo(
    () => question?.choices?.map((choice) => ({ ...choice, name: choice.value })) || [],
    [question?.choices],
  );

  return (
    <FormOptionsCheckboxes 
      {...cfg} 
      options={options} 
      label={getQuestionLabel(cfg)} 
      helperTextBelowLabel 
    />
  );
};

export default DynamicFormCheckboxes;